module.exports = "/build/web/images/footer.add2aa41c1969f40e8b0f9a86044f75e.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/footer.jpg
// module id = 121
// module chunks = 24